import React from 'react';
import classNames from 'classnames';
import { SML_SIZE } from '../constants/common';
var EditableInputsWrapper = function (_a) {
    var editable = _a.editable, children = _a.children, value = _a.value, _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size;
    if (typeof editable === 'undefined' || editable) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: "lfc-w-full" },
        React.createElement("p", { className: classNames('lfc-break-all lfc-text-gray-700', className, {
                'lfc-text-base lfc-text-gray-700 lfc-h-[40px] lfc-leading-[40px] lfc-px-[8px]': size === SML_SIZE.S,
                'lfc-text-lg lfc-text-gray-700 lfc-h-[56px] lfc-leading-[56px] lfc-px-[12px]': size !== SML_SIZE.S
            }) }, Array.isArray(value) ? value.join(' , ') : value || '')));
};
export default EditableInputsWrapper;
//# sourceMappingURL=EditableInputsWrapper.js.map